import { connect } from 'react-redux';
import FeatureFlagBoundary from './featureFlags';
import { getFeatureFlagsStatus } from './store/selectors';
import { loadFeatureFlags } from './store/action-creators';

const mapStateToProps = state => ({
  featureFlagsStatus: getFeatureFlagsStatus(state),
});

const mapDispatchToProps = { loadFeatureFlags };

export default connect(mapStateToProps, mapDispatchToProps)(FeatureFlagBoundary);
